import{j as e}from"../../../node_modules/react/jsx-runtime.js";var r=function(){return e.jsx(e.Fragment,{children:"Hello V1"})};export{r as default};
//# sourceMappingURL=index.js.map
